import { Component, effect, inject, input, output } from "@angular/core";
import { QuoteModalService } from "../../modals/quote-create-modal/quote-modal.service";
import { LoadingService } from "../../shared/services/loading-overlay/loading-overlay.component";
import { ContactforVendor, FieldScientistForVendor, QuoteDropdowns } from "./QuoteDropdowns";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { FormsModule } from "@angular/forms";
import { MatOptionModule } from "@angular/material/core";
  
@Component({
  selector: 'vendor-quote-filter',
  templateUrl: 'vendor-quote-filters.component.html',
  standalone: true,
  imports: [MatFormFieldModule, FormsModule, MatSelectModule, MatOptionModule],
  providers: [LoadingService, QuoteModalService]
})
export class VendorQuoteFilterComponent {
  private loadingService = inject(LoadingService);
  private quoteService = inject(QuoteModalService);

  private allFieldScientists: FieldScientistForVendor[] = [];
  private allContacts: ContactforVendor[] = [];

  protected Year: number;
  protected FieldScientistId: number;
  protected ContactId: number;

  public VendorId = input<number>();
  public ValuesRequired = input<boolean>(false);
  public ContactSelected = output<number>();
  public FieldScientistSelected = output<number>();
  public YearSelected = output<number>();

  constructor() {
    effect(() => {
      this.VendorId(); // track changes to VendorId
      this.Refresh();
    });
  }

  protected Dropdowns = {
    Years: <Array<number>>[],
    Contacts: <Array<ContactforVendor>>[],
    FieldScientists: <Array<FieldScientistForVendor>>[],
  }

  private Refresh() {
    if (this.VendorId() == null) return;

    const loadRef = this.loadingService.StartWaiting("Fetching data");
    this.quoteService.GetQuoteDropdowns(this.VendorId()).subscribe((dropdowns) => {
      if (dropdowns) this.SetDropdowns(dropdowns);
      loadRef.Stop();
    });
  }

  private SetDropdowns(dropdowns: QuoteDropdowns) {
    this.Dropdowns.Contacts = dropdowns.ContactsForVendor;
    this.Dropdowns.FieldScientists = dropdowns.FieldScientistsForVendor;
    this.Dropdowns.Years = dropdowns.Years;
    this.allContacts = dropdowns.ContactsForVendor;
    this.allFieldScientists = dropdowns.FieldScientistsForVendor;
  }

  protected onYearSelected(year: number) {
    this.Dropdowns.FieldScientists = this.allFieldScientists.filter((c) => c.Year == year);
    this.ContactId = null;
    this.FieldScientistId = null;
    this.YearSelected.emit(year);
  }

  protected onFieldScientistSelected(fieldScientistId: number) {
    this.Dropdowns.Contacts = this.allContacts.filter((c) => c.Associations.find((a) => a.FieldScientistId == fieldScientistId && a.Year == this.Year));
    this.ContactId = null;
    this.FieldScientistSelected.emit(fieldScientistId);
  }

  protected onContactSelected(contactId: number) {
    this.ContactSelected.emit(contactId);
  }
}
